import React from "react";

export const AdminDashboard = React.lazy(() => import("./AdminDashboard"));
